import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import myImg from "../../Assets/avatar.svg";
import Tilt from "react-parallax-tilt";
import {
  AiFillGithub,
  AiOutlineTwitter,
  AiFillInstagram,
} from "react-icons/ai";
import { FaLinkedinIn } from "react-icons/fa";

function Home2() {
  return (
    <Container fluid className="home-about-section" id="about">
      <Container>
        <Row>
          <Col md={8} className="home-about-description">
            <h1 style={{ fontSize: "2.6em" }}>
              SEJA MUITO <span className="purple"> BEM-VINDO! </span>
            </h1>
            <p className="home-about-body">
              Estudante de Ciência e Tecnologia na UFABC e jornalista pela Unesp de Bauru.
              <br />
              <br />Tenho conhecimentos em
              <i>
                <b className="purple"> HTML, CSS, Javascript, Python, Wordpress e metodologias ágeis (Scrum e Kanban).</b>
              </i>
              <br />
              <br />
              Trabalho com&nbsp;
              <i>
                <b className="purple">desenvolvimento de sites, landing pages, newsletters </b> 
                 e também {" "}
                <b className="purple">
                  com análise de dados.
                </b>
              </i>
              <br />
              <br />
              Sempre aprimorando <b className="purple">minhas habilidades.</b> Por isso, atualmente estudo
              <i>
                <b className="purple">
                  {" "}
                  SQL, Node.js e React.
                </b>
              </i>
            </p>
          </Col>
          <Col md={4} className="myAvtar">
            <Tilt>
              <img src={myImg} className="img-fluid" alt="avatar" />
            </Tilt>
          </Col>
        </Row>
        <Row>
          <Col md={12} className="home-about-social">
            <h1>Vamos conversar?</h1>
            <p>
              Entre em <span className="purple">contato </span>pelas redes sociais
            </p>
            <ul className="home-about-social-links">
              <li className="social-icons">
                <a
                  href="https://github.com/cinthiaquadrado"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiFillGithub />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://twitter.com/cinthiaquadrado"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <AiOutlineTwitter />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.linkedin.com/in/cinthiaquadrado/"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour  home-social-icons"
                >
                  <FaLinkedinIn />
                </a>
              </li>
              <li className="social-icons">
                <a
                  href="https://www.instagram.com/cinthiaquadrado"
                  target="_blank"
                  rel="noreferrer"
                  className="icon-colour home-social-icons"
                >
                  <AiFillInstagram />
                </a>
              </li>
            </ul>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}
export default Home2;
